var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calculator-personal-gain-result"},[_c('div',{staticClass:"calculator-personal-gain-result__total total"},[_c('h5',{staticClass:"total__title"},[_vm._v("Итоговая выгода")]),_c('p',{staticClass:"total__value"},[_vm._v(_vm._s(_vm.result.total)+" "),_c('span',[_vm._v("RC")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }